// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8357":"css/app.6876","9867":"css/admin-app.6876"}[chunkId] + ".css";
};